import React, { useCallback } from 'react';

import type { FieldProps } from '@rjsf/utils';

import { Box, Typography } from '@mui/material';

import BusinessAddressAutocomplete, { BusinessAddress } from './BusinessAddressAutocomplete';

/**
 * RJSF Field wrapper for BusinessAddressAutocomplete
 * This allows the address autocomplete to be used within RJSF forms for object types
 */
export default function BusinessAddressField({
  formData,
  onChange,
  disabled,
  readonly,
  schema,
  fieldPathId,
}: FieldProps) {
  const handleChange = useCallback(
    (address: BusinessAddress | null) => {
      onChange(address, fieldPathId.path);
    },
    [fieldPathId.path, onChange],
  );

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        {schema.title || 'Business Address'}
      </Typography>
      <BusinessAddressAutocomplete value={formData || null} onChange={handleChange} disabled={disabled || readonly} />
    </Box>
  );
}
